export const TokenType = {
  Company: "company",
  Admin: "admin",
  Master: "master",
} as const;

export const ApiKeyType = {
  OAUTH: "OAUTH",
  SERVICE: "SERVICE",
} as const;

export const SsoAuthType = {
  Saml: "saml",
  OpenId: "openid",
} as const;

export const REVOKED_SESSION_PREFIX = "revoked-session:";
/** Gateway caches validated SERVICE key identity by SHA-256(token). */
export const SERVICE_API_KEY_CACHE_PREFIX = "svc-api-key:";
/** Maps a SERVICE key id to its token-hash cache key for invalidation. */
export const SERVICE_API_KEY_CACHE_INDEX_PREFIX = "svc-api-key-index:";
export const PERMISSIONS_CACHE_PREFIX = "permissions:v2:";

export type TokenType = (typeof TokenType)[keyof typeof TokenType];
export type ApiKeyType = (typeof ApiKeyType)[keyof typeof ApiKeyType];
export type SsoAuthType = (typeof SsoAuthType)[keyof typeof SsoAuthType];

export function isSsoAuthType(
  value: string | null | undefined,
): value is SsoAuthType {
  return value === SsoAuthType.Saml || value === SsoAuthType.OpenId;
}
